
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as _91id_93Zy0_KOLbxNxb43N0y4b0vZ6V5j_URQw2k_UaO39v7PkMeta } from "/tmp/build_e118ec62/pages/Cases/Overview/[id].vue?macro=true";
import { default as _91id_93l9f0blYg0YgGgcDzWhZ8xnZDK4rGYbL8PZ62VAj1yvkMeta } from "/tmp/build_e118ec62/pages/Service Requests/Overview/[id].vue?macro=true";
import { default as indexgtSAW94B2CYO4vti3xWA9Fg5HpXWYkEIhEZXuO9cO08Meta } from "/tmp/build_e118ec62/pages/Cases/Overview/index.vue?macro=true";
import { default as _91id_939rdu8OGws52XLRrLmYjFBh_MqF8cPD_hoBpZVzKc8gcMeta } from "/tmp/build_e118ec62/pages/Companies/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93eDq4kjAZ3xC7rTYfmVrR1zOMAKgbRLFObrqT_3r1ibYMeta } from "/tmp/build_e118ec62/pages/Companies/Overview/Operations/[id].vue?macro=true";
import { default as _91id_933inaHPyP_JYGxWt6wCJNdttm7DXRKlnmsqSYDunx2zwMeta } from "/tmp/build_e118ec62/pages/Companies/Overview/Sales/[id].vue?macro=true";
import { default as indexM5aHaAHl1NUoGMnx2seD1qohbQVxarAMy3A2OdhitAUMeta } from "/tmp/build_e118ec62/pages/Companies/Overview/Activities/index.vue?macro=true";
import { default as indexl8YdvWTfNyAxJwLRIEsdmxVTKhEFUW4DScLejQRl2EMMeta } from "/tmp/build_e118ec62/pages/Companies/Overview/Operations/index.vue?macro=true";
import { default as indexCzRwB8TUgsznkvyZiiO2B_BErtzkO5zkkwNOCbMR0GMMeta } from "/tmp/build_e118ec62/pages/Companies/Overview/Sales/index.vue?macro=true";
import { default as OverviewSEn7wt9BZfFpQ8mHhFtHgpKPZkTBKqEtj2eBLREmvFIMeta } from "/tmp/build_e118ec62/pages/Companies/Overview.vue?macro=true";
import { default as _91id_93Sf8Tkpm9sIrq68BU3eclrxce7Sx6_JySlG6CM0nsKgkMeta } from "/tmp/build_e118ec62/pages/Home/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93gmC5ni9pgbrIJMUSllraqV7v3U1BUMFON6N_u_jp8kUMeta } from "/tmp/build_e118ec62/pages/Home/Overview/Operations/[id].vue?macro=true";
import { default as _91id_933JSYhlaul78xcQ1MTUjDfeZhxXB3DN6CrmOqGk4klHQMeta } from "/tmp/build_e118ec62/pages/Home/Overview/Sales/[id].vue?macro=true";
import { default as _91id_937td_0ACyMVrdw1Ixv6JAPIslu9DyFyWtCDUeQfxnKg4Meta } from "/tmp/build_e118ec62/pages/Home/Overview/Splits/[id].vue?macro=true";
import { default as indexjZ68rbbAVmecDyFrzTGJNNMHuoaWVw_WtxfDLCrCQ_4Meta } from "/tmp/build_e118ec62/pages/Home/Overview/Activities/index.vue?macro=true";
import { default as index8Fdr2Z7pnzrV5jH3ZZE71MijX3WRCABH652EAZA4qqAMeta } from "/tmp/build_e118ec62/pages/Home/Overview/Operations/index.vue?macro=true";
import { default as index2WiJRd14uwM6pu_n5naSPaBXHIzl1LmkqfFXS4nJB3gMeta } from "/tmp/build_e118ec62/pages/Home/Overview/Sales/index.vue?macro=true";
import { default as indexr6D1127T_4lpSQS7Gkffv3t_enEeB1Rse6xvYeNUB7cMeta } from "/tmp/build_e118ec62/pages/Home/Overview/Splits/index.vue?macro=true";
import { default as OverviewrWFOnzZzHQTFc2rMpUpgx0iDx67TyaueZTtKJMFwjrgMeta } from "/tmp/build_e118ec62/pages/Home/Overview.vue?macro=true";
import { default as _91id_933TcQDLjSeNBlIHiixPRg4oUyGLLT1zed_qQzE5oIosAMeta } from "/tmp/build_e118ec62/pages/Opportunities/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93XPgK4a7gStZ75vWh6a2tAI8Y7Yd5f_yHNplXNu0kA_EMeta } from "/tmp/build_e118ec62/pages/Opportunities/Overview/Operations/[id].vue?macro=true";
import { default as _91id_93RxSmyvcS6sW1wTAg3Tksn0l2p0ocBgVOqQo77fx404kMeta } from "/tmp/build_e118ec62/pages/Opportunities/Overview/Sales/[id].vue?macro=true";
import { default as indexDb5A_aWzldUvne4liOSWtPj7vKTqIFDBs0ykiQlZlf8Meta } from "/tmp/build_e118ec62/pages/Opportunities/Overview/Activities/index.vue?macro=true";
import { default as indexMM9F_8yVpG05oQNKrTe27MSMqKsIaq9iO6vHIDkfrEgMeta } from "/tmp/build_e118ec62/pages/Opportunities/Overview/Operations/index.vue?macro=true";
import { default as indexdqRUzBTNLKxc5QD2XY820c8OZthx977DQ6O_UqoZodwMeta } from "/tmp/build_e118ec62/pages/Opportunities/Overview/Sales/index.vue?macro=true";
import { default as Overview4qqTf36_PXVuST8eFKkhXnOqGK9mYdGGj8pQOavFCgEMeta } from "/tmp/build_e118ec62/pages/Opportunities/Overview.vue?macro=true";
import { default as _91id_93A_uqcc3UZl5JQxrywPE1BFkW1CQUbXrXHgBR7X5jQJEMeta } from "/tmp/build_e118ec62/pages/Orders/Overview/Activities/[id].vue?macro=true";
import { default as _91id_93gVt2Mgo3XAbCkADNiWK_uWtU_AhfEtL7xp1dZQBJsgUMeta } from "/tmp/build_e118ec62/pages/Orders/Overview/Sales/[id].vue?macro=true";
import { default as index7bimQU0tbtIlSrRT_52bi8p_WzMrc9cLhh8UBUJubBkMeta } from "/tmp/build_e118ec62/pages/Orders/Overview/Activities/index.vue?macro=true";
import { default as indexcndNLITK5CeXhKtbpRJlZM0_ysXoVzT5AtBP1HFpHCUMeta } from "/tmp/build_e118ec62/pages/Orders/Overview/Sales/index.vue?macro=true";
import { default as Overview0tVtP_qJBmq41FdXAtnvxmCCXOJJ_9dRxXhgIMK0yoUMeta } from "/tmp/build_e118ec62/pages/Orders/Overview.vue?macro=true";
import { default as indexhj8QhRZy_hMTrofZ_1pjryGpnRmn13H2JdRjNsuwtQQMeta } from "/tmp/build_e118ec62/pages/Service Requests/Overview/index.vue?macro=true";
import { default as _91id_931N0OBup9d7pDiQMia61cGHtat_9_vw94FlQU3LBFnqAMeta } from "/tmp/build_e118ec62/pages/Suppliers/Overview/Activities/[id].vue?macro=true";
import { default as _91id_933Hq9BVLF8uZSiylBctkTmLOJpatlHxq7rxHsz8CfVsIMeta } from "/tmp/build_e118ec62/pages/Suppliers/Overview/Sales/[id].vue?macro=true";
import { default as index17rTVJxI3KoTV7SzF6pLS5y9BxQdi247QJ8HUdE4mM4Meta } from "/tmp/build_e118ec62/pages/Suppliers/Overview/Activities/index.vue?macro=true";
import { default as indexrKxxEOSpftPcN3qkkFKm_AjcTnGUBUTIyBGhht_EdPcMeta } from "/tmp/build_e118ec62/pages/Suppliers/Overview/Sales/index.vue?macro=true";
import { default as Overviewl5PZxCLyoLroWB9R0V5x4DH_csNib5EruA8VKNkaFJMMeta } from "/tmp/build_e118ec62/pages/Suppliers/Overview.vue?macro=true";
import { default as _91id_93xrT6MRvfTH9ELgDveQ6JZ6SdhcDUNRs5IsAAQt1Vlj4Meta } from "/tmp/build_e118ec62/pages/Accounts/[id].vue?macro=true";
import { default as _91id_93q355ZuqA0Hn7mNLXPHFgKNv8XytaIvDuTkdSOc_XyM4Meta } from "/tmp/build_e118ec62/pages/Field Sets/[id].vue?macro=true";
import { default as _91id_93_3yRTeYnP72Sua0GItDw7WbYL6pfPDYfZDQ5IWoUJSwMeta } from "/tmp/build_e118ec62/pages/Industries/[id].vue?macro=true";
import { default as _91id_930hNLByo764sGA6heziuGMaCalW1s3SPErUDRlHqA1GwMeta } from "/tmp/build_e118ec62/pages/Locations/[id].vue?macro=true";
import { default as _91id_93kASv74JN6hA30ok4QeHTfcRyZUuF4TfpGjgY7NmDDXkMeta } from "/tmp/build_e118ec62/pages/Product Categories/[id].vue?macro=true";
import { default as _91id_93RMlQXGEic5oWa09qbOQLMcoHaCrYtOsjvZI7LKX9VPgMeta } from "/tmp/build_e118ec62/pages/Product Groups/[id].vue?macro=true";
import { default as _91id_93k6nLWeMt6yC0PR2Fh8xpIuE_tiRtMemGPIntaymgX9IMeta } from "/tmp/build_e118ec62/pages/Product Subcategories/[id].vue?macro=true";
import { default as _91id_932nuQOtr2iidybO2_yjjqz1JIpIQCp9dPgE0vn2AS9qoMeta } from "/tmp/build_e118ec62/pages/Products/[id].vue?macro=true";
import { default as _91id_93QYaWZRh7riMD_B3UmG17LYGB3CYOhNFzy8v6C5pKRuwMeta } from "/tmp/build_e118ec62/pages/Projects/[id].vue?macro=true";
import { default as _91id_93TnjzGBPcKDHZnTsgdt_Zzwh1pk7jaXEbhlq9_q8Q0ycMeta } from "/tmp/build_e118ec62/pages/SupplierProducts/[id].vue?macro=true";
import { default as _91id_93GjJgvRNdn0rME9tXmN0zdM68EMPUCqcNajdh4V_FN60Meta } from "/tmp/build_e118ec62/pages/Team Members/[id].vue?macro=true";
import { default as _91id_93kzmxGcOA9qZK8vhBNZdn3o2Ik30ePvZa_vvuHYDVyg0Meta } from "/tmp/build_e118ec62/pages/TSDs/[id].vue?macro=true";
import { default as indexYGGrFKgObRCzWMIIwRGn4xSWvvhSvtaAkHstkE8rj0MMeta } from "/tmp/build_e118ec62/pages/Accounts/index.vue?macro=true";
import { default as indexA_tkmjq1CwKUd6vlxakkoEMf75du81pxLrzLJfREo8gMeta } from "/tmp/build_e118ec62/pages/Case Types/index.vue?macro=true";
import { default as indexq8iXk98HWTItAGNfZLJZcS_5AAsC3aAGF1rhkgk2mOEMeta } from "/tmp/build_e118ec62/pages/Cases/index.vue?macro=true";
import { default as indexQnih_i_nMRGJ9juC6I9HI_EUXBN9SU_mP72qlYQPN_sMeta } from "/tmp/build_e118ec62/pages/Companies/index.vue?macro=true";
import { default as indexRN7z_uGGl9j4IzOTboAoZhlIaih7bBE1MZHahwjd0iYMeta } from "/tmp/build_e118ec62/pages/Company Contact Roles/index.vue?macro=true";
import { default as indexrAXfEgbm30AhBnqUarBpeweYJlwWyxZx0KzL1ucu0zcMeta } from "/tmp/build_e118ec62/pages/Contacts/index.vue?macro=true";
import { default as indexZKwkQtFuE8xdY30QQGps0DsnA6GIjR_MXQ5E9tvfc8UMeta } from "/tmp/build_e118ec62/pages/Dashboard/index.vue?macro=true";
import { default as indexzyAkBgjqLrQNZNz7avvW2VtithXURvrdUE4NGxrKLukMeta } from "/tmp/build_e118ec62/pages/Field Sets/index.vue?macro=true";
import { default as indexYTIAsnJ9EwiWs47qjSH0YEcoTesHY0VRmxLRd40xImYMeta } from "/tmp/build_e118ec62/pages/Groups/index.vue?macro=true";
import { default as indexfspQKVy8qczsm03W1eKQpnvtJw8dKjCGdLuX7lVyNScMeta } from "/tmp/build_e118ec62/pages/Home/index.vue?macro=true";
import { default as indexp2al9tIEdbo_hLvD8HX7Dnv_q0OGFIXs4lyesnO9tGIMeta } from "/tmp/build_e118ec62/pages/Industries/index.vue?macro=true";
import { default as indexT9ztC7yPLST6TsgKGRoCl9POyzAuwitjAWzOW_GrO8UMeta } from "/tmp/build_e118ec62/pages/Lead Source Campaigns/index.vue?macro=true";
import { default as index2uloDBofq1k4c_DWqOjgIMluNRysdUtwzDsxK2u531AMeta } from "/tmp/build_e118ec62/pages/Lead Source Contacts/index.vue?macro=true";
import { default as index_ck8JpiDXdsQKRFtlhVaHmpKUGWjBK7HFq6UMK9uqd8Meta } from "/tmp/build_e118ec62/pages/Lead Source Events/index.vue?macro=true";
import { default as indexZ2u0CzGYyqkU7_X2GU_5r2pCXxjGbPkZ_6soBS7GYQcMeta } from "/tmp/build_e118ec62/pages/Location Types/index.vue?macro=true";
import { default as indexZ0IPEpAYpRTNkbtwFWneqfDJHTpKGSoZ_H7pppNeeJsMeta } from "/tmp/build_e118ec62/pages/Login/index.vue?macro=true";
import { default as indexDDnVtlPR_0z_WDSHv5P2JWAcStF9rNdfEgg4f3I9c_MMeta } from "/tmp/build_e118ec62/pages/Opportunities/index.vue?macro=true";
import { default as indexxAV1xotLBq2Tfyl9spSWU6QqVGQZdoUdJdoVYFW49DgMeta } from "/tmp/build_e118ec62/pages/Opportunity Stages/index.vue?macro=true";
import { default as index_jTMSHu_jil6RNZtS_fBMiDdLQL45P_r_08oIqQee_IMeta } from "/tmp/build_e118ec62/pages/Orders/index.vue?macro=true";
import { default as indexPy7ewFg2VLE4f1gr3UF0zuhZzXdCsacD372NhjrwpE0Meta } from "/tmp/build_e118ec62/pages/Payables/index.vue?macro=true";
import { default as index73Z1yBDsiVHydn4qdz_NFOYfr3AHizpSUPkrpysPW1oMeta } from "/tmp/build_e118ec62/pages/Persons/index.vue?macro=true";
import { default as indexTqzAhWrRX_x5qXRZchTH0QOComq5jGHusZOAFlvVba8Meta } from "/tmp/build_e118ec62/pages/Product Categories/index.vue?macro=true";
import { default as index5pGCgMDfGkJYtr6z_d5tKf_yojHESIy33rCYZKoEypkMeta } from "/tmp/build_e118ec62/pages/Product Groups/index.vue?macro=true";
import { default as index7g5ZzXdPf7w_tRR7aAtj6gjqmMhprPCYY8ceEka3SYwMeta } from "/tmp/build_e118ec62/pages/Product Subcategories/index.vue?macro=true";
import { default as indexADX6lyno3Mj3vxC7xqr_wuzywA5JyNF9WA_aTCcxpHoMeta } from "/tmp/build_e118ec62/pages/Projects/index.vue?macro=true";
import { default as index_0O6atBWQFvI3roah7bFePZvP5sSoRU_5UIhEOv970YMeta } from "/tmp/build_e118ec62/pages/Receivables/index.vue?macro=true";
import { default as indexfAu9XmKa2X5RicP7OCKNRFQYBH_T32BBJiFK1AmoHmIMeta } from "/tmp/build_e118ec62/pages/Service Request Types/index.vue?macro=true";
import { default as indexaTmlq_Uda5npPV9KN_vPwsotPWApgKlAH3m35t_OgE4Meta } from "/tmp/build_e118ec62/pages/Service Requests/index.vue?macro=true";
import { default as indextLkx4WB2bYFr4qX7VyNjR7pa6MGhEg5f_bA7l7jFl9QMeta } from "/tmp/build_e118ec62/pages/Settings/index.vue?macro=true";
import { default as indexHeHZzFMZ2IYKhFk__v6nPRQZGmBLsvo2_jDYFUJjrYgMeta } from "/tmp/build_e118ec62/pages/Supplier Contact Roles/index.vue?macro=true";
import { default as indexyvDHVEUyCPmZ6iVuz5gnYQ_PCq8bBhmvT0G_jGkOAhYMeta } from "/tmp/build_e118ec62/pages/Suppliers/index.vue?macro=true";
import { default as indextYv7G739Zh6OgLHQG0bAU6MqFn1K5qR5BpfKEkzINyEMeta } from "/tmp/build_e118ec62/pages/Team Members/index.vue?macro=true";
import { default as indexDy7vEg9_qlvLRZgbPbu_9LMp9Dh9u58GG1BQPn7vM08Meta } from "/tmp/build_e118ec62/pages/TSD Contact Roles/index.vue?macro=true";
import { default as indexORFLjAyf0gysr_TNmoCAsry5_jH0oFyFkUkECbLPTAgMeta } from "/tmp/build_e118ec62/pages/TSDs/index.vue?macro=true";
import { default as indexXmuFD5uas4elEIGihSlZdAHB_r8Ozim2QMpNWvE66zQMeta } from "/tmp/build_e118ec62/pages/User/index.vue?macro=true";
import { default as indexwQ9KGTlA4ZoH_xg7GBSXvR15wf_pgWcMLMI2yOjwCRcMeta } from "/tmp/build_e118ec62/pages/Users/index.vue?macro=true";
import { default as indexghHeppYLkhUzruZHLVuWlJGFnDxnqyHq_I_zxYL9JeQMeta } from "/tmp/build_e118ec62/pages/index.vue?macro=true";
export default [
  {
    name: "Cases-Overview-id",
    path: "/Cases/Overview/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Cases/Overview/[id].vue")
  },
  {
    name: "Service Requests-Overview-id",
    path: "/Service%20Requests/Overview/:id()",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_e118ec62/pages/Service Requests/Overview/[id].vue")
  },
  {
    name: "Cases-Overview",
    path: "/Cases/Overview",
    component: () => import("/tmp/build_e118ec62/pages/Cases/Overview/index.vue")
  },
  {
    name: "Companies-Overview",
    path: "/Companies/Overview",
    component: () => import("/tmp/build_e118ec62/pages/Companies/Overview.vue"),
    children: [
  {
    name: "Companies-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Companies/Overview/Activities/[id].vue")
  },
  {
    name: "Companies-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Companies/Overview/Operations/[id].vue")
  },
  {
    name: "Companies-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Companies/Overview/Sales/[id].vue")
  },
  {
    name: "Companies-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_e118ec62/pages/Companies/Overview/Activities/index.vue")
  },
  {
    name: "Companies-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_e118ec62/pages/Companies/Overview/Operations/index.vue")
  },
  {
    name: "Companies-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_e118ec62/pages/Companies/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Home-Overview",
    path: "/Home/Overview",
    component: () => import("/tmp/build_e118ec62/pages/Home/Overview.vue"),
    children: [
  {
    name: "Home-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Home/Overview/Activities/[id].vue")
  },
  {
    name: "Home-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Home/Overview/Operations/[id].vue")
  },
  {
    name: "Home-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Home/Overview/Sales/[id].vue")
  },
  {
    name: "Home-Overview-Splits-id",
    path: "Splits/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Home/Overview/Splits/[id].vue")
  },
  {
    name: "Home-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_e118ec62/pages/Home/Overview/Activities/index.vue")
  },
  {
    name: "Home-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_e118ec62/pages/Home/Overview/Operations/index.vue")
  },
  {
    name: "Home-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_e118ec62/pages/Home/Overview/Sales/index.vue")
  },
  {
    name: "Home-Overview-Splits",
    path: "Splits",
    component: () => import("/tmp/build_e118ec62/pages/Home/Overview/Splits/index.vue")
  }
]
  },
  {
    name: "Opportunities-Overview",
    path: "/Opportunities/Overview",
    component: () => import("/tmp/build_e118ec62/pages/Opportunities/Overview.vue"),
    children: [
  {
    name: "Opportunities-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Opportunities/Overview/Activities/[id].vue")
  },
  {
    name: "Opportunities-Overview-Operations-id",
    path: "Operations/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Opportunities/Overview/Operations/[id].vue")
  },
  {
    name: "Opportunities-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Opportunities/Overview/Sales/[id].vue")
  },
  {
    name: "Opportunities-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_e118ec62/pages/Opportunities/Overview/Activities/index.vue")
  },
  {
    name: "Opportunities-Overview-Operations",
    path: "Operations",
    component: () => import("/tmp/build_e118ec62/pages/Opportunities/Overview/Operations/index.vue")
  },
  {
    name: "Opportunities-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_e118ec62/pages/Opportunities/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Orders-Overview",
    path: "/Orders/Overview",
    component: () => import("/tmp/build_e118ec62/pages/Orders/Overview.vue"),
    children: [
  {
    name: "Orders-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Orders/Overview/Activities/[id].vue")
  },
  {
    name: "Orders-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Orders/Overview/Sales/[id].vue")
  },
  {
    name: "Orders-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_e118ec62/pages/Orders/Overview/Activities/index.vue")
  },
  {
    name: "Orders-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_e118ec62/pages/Orders/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Service Requests-Overview",
    path: "/Service%20Requests/Overview",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_e118ec62/pages/Service Requests/Overview/index.vue")
  },
  {
    name: "Suppliers-Overview",
    path: "/Suppliers/Overview",
    component: () => import("/tmp/build_e118ec62/pages/Suppliers/Overview.vue"),
    children: [
  {
    name: "Suppliers-Overview-Activities-id",
    path: "Activities/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Suppliers/Overview/Activities/[id].vue")
  },
  {
    name: "Suppliers-Overview-Sales-id",
    path: "Sales/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Suppliers/Overview/Sales/[id].vue")
  },
  {
    name: "Suppliers-Overview-Activities",
    path: "Activities",
    component: () => import("/tmp/build_e118ec62/pages/Suppliers/Overview/Activities/index.vue")
  },
  {
    name: "Suppliers-Overview-Sales",
    path: "Sales",
    component: () => import("/tmp/build_e118ec62/pages/Suppliers/Overview/Sales/index.vue")
  }
]
  },
  {
    name: "Accounts-id",
    path: "/Accounts/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Accounts/[id].vue")
  },
  {
    name: "Field Sets-id",
    path: "/Field%20Sets/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Field Sets/[id].vue")
  },
  {
    name: "Industries-id",
    path: "/Industries/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Industries/[id].vue")
  },
  {
    name: "Locations-id",
    path: "/Locations/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Locations/[id].vue")
  },
  {
    name: "Product Categories-id",
    path: "/Product%20Categories/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Product Categories/[id].vue")
  },
  {
    name: "Product Groups-id",
    path: "/Product%20Groups/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Product Groups/[id].vue")
  },
  {
    name: "Product Subcategories-id",
    path: "/Product%20Subcategories/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Product Subcategories/[id].vue")
  },
  {
    name: "Products-id",
    path: "/Products/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Products/[id].vue")
  },
  {
    name: "Projects-id",
    path: "/Projects/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Projects/[id].vue")
  },
  {
    name: "SupplierProducts-id",
    path: "/SupplierProducts/:id()",
    component: () => import("/tmp/build_e118ec62/pages/SupplierProducts/[id].vue")
  },
  {
    name: "Team Members-id",
    path: "/Team%20Members/:id()",
    component: () => import("/tmp/build_e118ec62/pages/Team Members/[id].vue")
  },
  {
    name: "TSDs-id",
    path: "/TSDs/:id()",
    component: () => import("/tmp/build_e118ec62/pages/TSDs/[id].vue")
  },
  {
    name: "Accounts",
    path: "/Accounts",
    component: () => import("/tmp/build_e118ec62/pages/Accounts/index.vue")
  },
  {
    name: "Case Types",
    path: "/Case%20Types",
    component: () => import("/tmp/build_e118ec62/pages/Case Types/index.vue")
  },
  {
    name: "Cases",
    path: "/Cases",
    component: () => import("/tmp/build_e118ec62/pages/Cases/index.vue")
  },
  {
    name: "Companies",
    path: "/Companies",
    component: () => import("/tmp/build_e118ec62/pages/Companies/index.vue")
  },
  {
    name: "Company Contact Roles",
    path: "/Company%20Contact%20Roles",
    component: () => import("/tmp/build_e118ec62/pages/Company Contact Roles/index.vue")
  },
  {
    name: "Contacts",
    path: "/Contacts",
    component: () => import("/tmp/build_e118ec62/pages/Contacts/index.vue")
  },
  {
    name: "Dashboard",
    path: "/Dashboard",
    component: () => import("/tmp/build_e118ec62/pages/Dashboard/index.vue")
  },
  {
    name: "Field Sets",
    path: "/Field%20Sets",
    component: () => import("/tmp/build_e118ec62/pages/Field Sets/index.vue")
  },
  {
    name: "Groups",
    path: "/Groups",
    component: () => import("/tmp/build_e118ec62/pages/Groups/index.vue")
  },
  {
    name: "Home",
    path: "/Home",
    meta: {"middleware":["home-redirect"]},
    component: () => import("/tmp/build_e118ec62/pages/Home/index.vue")
  },
  {
    name: "Industries",
    path: "/Industries",
    component: () => import("/tmp/build_e118ec62/pages/Industries/index.vue")
  },
  {
    name: "Lead Source Campaigns",
    path: "/Lead%20Source%20Campaigns",
    component: () => import("/tmp/build_e118ec62/pages/Lead Source Campaigns/index.vue")
  },
  {
    name: "Lead Source Contacts",
    path: "/Lead%20Source%20Contacts",
    component: () => import("/tmp/build_e118ec62/pages/Lead Source Contacts/index.vue")
  },
  {
    name: "Lead Source Events",
    path: "/Lead%20Source%20Events",
    component: () => import("/tmp/build_e118ec62/pages/Lead Source Events/index.vue")
  },
  {
    name: "Location Types",
    path: "/Location%20Types",
    component: () => import("/tmp/build_e118ec62/pages/Location Types/index.vue")
  },
  {
    name: "Login",
    path: "/Login",
    meta: indexZ0IPEpAYpRTNkbtwFWneqfDJHTpKGSoZ_H7pppNeeJsMeta || {},
    component: () => import("/tmp/build_e118ec62/pages/Login/index.vue")
  },
  {
    name: "Opportunities",
    path: "/Opportunities",
    component: () => import("/tmp/build_e118ec62/pages/Opportunities/index.vue")
  },
  {
    name: "Opportunity Stages",
    path: "/Opportunity%20Stages",
    component: () => import("/tmp/build_e118ec62/pages/Opportunity Stages/index.vue")
  },
  {
    name: "Orders",
    path: "/Orders",
    component: () => import("/tmp/build_e118ec62/pages/Orders/index.vue")
  },
  {
    name: "Payables",
    path: "/Payables",
    component: () => import("/tmp/build_e118ec62/pages/Payables/index.vue")
  },
  {
    name: "Persons",
    path: "/Persons",
    component: () => import("/tmp/build_e118ec62/pages/Persons/index.vue")
  },
  {
    name: "Product Categories",
    path: "/Product%20Categories",
    component: () => import("/tmp/build_e118ec62/pages/Product Categories/index.vue")
  },
  {
    name: "Product Groups",
    path: "/Product%20Groups",
    component: () => import("/tmp/build_e118ec62/pages/Product Groups/index.vue")
  },
  {
    name: "Product Subcategories",
    path: "/Product%20Subcategories",
    component: () => import("/tmp/build_e118ec62/pages/Product Subcategories/index.vue")
  },
  {
    name: "Projects",
    path: "/Projects",
    component: () => import("/tmp/build_e118ec62/pages/Projects/index.vue")
  },
  {
    name: "Receivables",
    path: "/Receivables",
    component: () => import("/tmp/build_e118ec62/pages/Receivables/index.vue")
  },
  {
    name: "Service Request Types",
    path: "/Service%20Request%20Types",
    meta: {"middleware":["service-requests-gate"]},
    component: () => import("/tmp/build_e118ec62/pages/Service Request Types/index.vue")
  },
  {
    name: "Service Requests",
    path: "/Service%20Requests",
    component: () => import("/tmp/build_e118ec62/pages/Service Requests/index.vue")
  },
  {
    name: "Settings",
    path: "/Settings",
    component: () => import("/tmp/build_e118ec62/pages/Settings/index.vue")
  },
  {
    name: "Supplier Contact Roles",
    path: "/Supplier%20Contact%20Roles",
    component: () => import("/tmp/build_e118ec62/pages/Supplier Contact Roles/index.vue")
  },
  {
    name: "Suppliers",
    path: "/Suppliers",
    component: () => import("/tmp/build_e118ec62/pages/Suppliers/index.vue")
  },
  {
    name: "Team Members",
    path: "/Team%20Members",
    component: () => import("/tmp/build_e118ec62/pages/Team Members/index.vue")
  },
  {
    name: "TSD Contact Roles",
    path: "/TSD%20Contact%20Roles",
    component: () => import("/tmp/build_e118ec62/pages/TSD Contact Roles/index.vue")
  },
  {
    name: "TSDs",
    path: "/TSDs",
    component: () => import("/tmp/build_e118ec62/pages/TSDs/index.vue")
  },
  {
    name: "User",
    path: "/User",
    component: () => import("/tmp/build_e118ec62/pages/User/index.vue")
  },
  {
    name: "Users",
    path: "/Users",
    component: () => import("/tmp/build_e118ec62/pages/Users/index.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/build_e118ec62/pages/index.vue")
  }
]